<template>
  <v-data-table
    v-bind="dataTableProps"
    :headers="headers"
    :items="items"
    :loading="$wait.is('fetching inventorycount')"
    :must-sort="false"
    :options.sync="pagination"
    :sort-desc="false"
    disable-pagination
    hide-default-footer
    sort-by="sequence"
    @current-items="setCurrentItems"
  >
    <template v-slot:header.created>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="isPending(inventoryCount) && currentItems.length"
            :loading="$wait.is(`removing all items`)"
            icon
            ripple
            small
            v-on="on"
            @click="removeAllProducts"
          >
            <v-icon size="12px">fal fa-trash-alt</v-icon>
          </v-btn>
        </template>
        <span>{{ helpers.capitalize($t('Remove {0}', [$t('All Items')])) }}</span>
      </v-tooltip>
    </template>
    <template v-slot:item="props">
      <tr
        v-if="props.item.product"
        :class="{'active': activeItem.productId === _.get(props.item, 'product.id')}"
        style="cursor: pointer"
        @click="selectTableRow(props.item)"
      >
        <td>
          <v-icon
            v-if="props.item.counted"
            color="success"
          >fal fa-box-check</v-icon>
          <template v-else>
            <v-btn
              v-show="isPending(inventoryCount)"
              :loading="$wait.is(`removing item ${props.item.uuid}`)"
              class="ma-0"
              icon
              ripple
              small
              @click="removeProduct(props.item)"
            >
              <v-icon size="12px">fal fa-trash-alt</v-icon>
            </v-btn>
          </template>
        </td>
        <td>{{ _.get(props.item.product, 'name') }}</td>
        <td>{{ _.get(props.item.product, 'brand.name', '-') }}</td>
        <td>{{ _.get(props.item, 'currentStock', $t('n/a')) }}</td>
        <td>
          <template v-if="props.item.previousCounted">
            {{ props.item.previousCounted || '-' | moment("DD MMMM YYYY HH:mm") }} (<small>{{ `${props.item.previousCountedStock} ${$t('Pc.').toLowerCase()}` }}</small>)
          </template>
          <template v-else> - </template>
        </td>
        <td>
          <template v-if="isIncoming(inventoryCount) && props.item.newStock">+</template>
          <template v-if="Number.isInteger(props.item.newStock)">{{ props.item.newStock }}</template>
          <template v-else>
            <v-chip
              color="red"
              label
              small
              text-color="white"
            >{{ $t('Not yet counted') }}</v-chip>
          </template>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { VDataTableDefaultProps as dataTableProps } from '@/utils/default-props/v-data-table'
import inventoryCountService from '@/services/inventory-counts'
import inventoryCountInfoMixin from '@/utils/mixins/inventoryCountInfoMixin'
export default {
  name: 'InventoryCountsCounterProducts',

  mixins: [inventoryCountInfoMixin],

  props: {
    activeItem: {
      default: null,
      required: true,
      type: Object
    },
    items: {
      required: true,
      type: Array
    },
    inventoryCount: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      currentItems: null,
      dataTableProps,
      headers: [
        {
          text: '',
          value: 'created',
          width: '20px',
          sortable: false
        },
        {
          text: this.$t('Product'),
          value: 'product.name'
        },
        {
          text: this.$t('Brand'),
          value: 'product.brand.name'
        },
        {
          text: this.$t('Current Stock'),
          value: 'currentStock'
        },
        {
          text: this.$t('Previous Count'),
          value: 'previousCounted'
        },
        {
          text: this.$t('Counted Number'),
          value: 'newStock',
          width: '175px'
        }
      ],
      pagination: {}
    }
  },

  watch: {
    pagination: {
      handler (newPagination) {
        if (this.pagination.sortBy[0] === 'previousCounted') {
          this.pagination.sortBy[1] = 'product.brand.name'
          this.pagination.sortDesc[1] = false
          this.pagination.multiSort = true
        } else {
          this.pagination.multiSort = false
        }
      }
    }
  },

  methods: {
    removeAllProducts () {
      this.$swal({
        title: this.$t('Are you sure?'),
        type: 'warning',
        cancelButtonText: this.$t('Cancel'),
        confirmButtonText: this.$t('Yes'),
        showCancelButton: true,
        reverseButtons: true
      })
        .then((result) => {
          if (result.value) {
            this.$wait.start('removing all items')
            inventoryCountService.removeAllItems(this.inventoryCount.uuid)
              .then((data) => this.helpers.toastSuccess(data.data.message))
              .catch(data => { if (data && data.data.message) this.helpers.toastError(data.data.message) })
              .finally(() => {
                this.$wait.end('removing all items')
                this.$emit('items-removed')
              })
          }
        })
    },
    removeProduct (item) {
      this.$wait.start(`removing item ${item.uuid}`)
      inventoryCountService.removeItem(item.uuid)
        .then((data) => this.helpers.toastSuccess(data.data.message))
        // .catch(data => { if (data && data.data.message) this.helpers.toastError(data.data.message) })
        .finally(() => {
          this.$wait.end(`removing item ${item.uuid}`)
          this.$emit('item-removed', item)
        })
    },
    selectTableRow (row) {
      this.$emit('item-selected', row)
    },
    setCurrentItems (items) {
      this.currentItems = items
      this.$emit('current-items', items)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory-counts/InventoryCountsCounterProducts.vue